import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router';
import App from './App';
import { Provider } from 'react-redux';
import { store } from './store';
import { Suspense } from 'react';
import LoadingPage from './layouts/components/LoadingPage';
import PrivacyPolicy from './pages/legal/PrivacyPolicy';

const LandingPage = React.lazy(() => import('./pages/LandingPage'));
const Contact = React.lazy(() => import('./pages/legal/Contact'));
const WebDeprecatedPage = React.lazy(() => import('./pages/WebDeprecatedPage'));

const SuspenseWrapper = ({ children }: { children: React.ReactNode }) => (
  <Suspense fallback={<LoadingPage inside />}>
    {children}
  </Suspense>
);

/*
 * Legacy app routes (kept in repo, unhooked from web router):
 * Layout dashboard, sign-in/up, home, clubs, events, invitations, etc.
 * See git history in main.tsx for full route tree.
 */

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      {
        index: true,
        element: <SuspenseWrapper><LandingPage /></SuspenseWrapper>
      },
      {
        path: "/privacy-policy",
        element: <SuspenseWrapper><PrivacyPolicy /></SuspenseWrapper>
      },
      {
        path: "/privacy-policy-signup",
        element: <SuspenseWrapper><PrivacyPolicy /></SuspenseWrapper>
      },
      {
        path: "/support-signup",
        element: <SuspenseWrapper><Contact /></SuspenseWrapper>
      },
      {
        path: "*",
        element: <SuspenseWrapper><WebDeprecatedPage /></SuspenseWrapper>
      }
    ]
  }
]);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <Provider store={store}>
    <RouterProvider router={router} />
  </Provider>
);
